import { render, staticRenderFns } from "./TheStudy.vue?vue&type=template&id=5ecccd67&scoped=true&"
import script from "./TheStudy.vue?vue&type=script&lang=js&"
export * from "./TheStudy.vue?vue&type=script&lang=js&"
import style0 from "./TheStudy.vue?vue&type=style&index=0&id=5ecccd67&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecccd67",
  null
  
)

export default component.exports